module.exports = __webpack_public_path__ + "img/icon-16.ebc2b775.jpg";